import { createModule } from './modules';

// How long we'll check the connection.
const TICK_INTERVAL = 3_000;

// How long we'll wait before assuming we've lost contact with the server.
const CUTOFF_TIME = 12_000;

export class PingPongModule extends createModule('pingpong') {
  constructor(syncClient) {
    super(syncClient);
    this.syncClient = syncClient;

    this.packetHandlers = {
      PING: 'onPingReceived',
    };

    this.interval = setInterval(this.tick.bind(this), TICK_INTERVAL);
    this.lastContact = Number.MAX_SAFE_INTEGER;
  }

  tick() {
    if (Date.now() - this.lastContact > CUTOFF_TIME) {
      this.syncClient.socket.close();

      // WebSocket treats .close() as more of an eventual suggestion.  Dispatch an error now so that a message can be
      //   displayed immediately.
      this.syncClient.dispatchEvent({
        type: 'error',
        error: new Error('Lost connection with server; client initiated socket close.'),
      });

      // Clean up to ensure multiple errors won't be dispatched.
      clearInterval(this.interval);
    }
  }

  onPingReceived() {
    this.lastContact = Date.now();
    this.syncClient.sendPacket('$server', 'PONG');
  }
}
